module.exports = __webpack_public_path__ + "img/_bar1.19b3a86e.png";